var angular = require('angular');

var DistributionRoutePlan = require('./distributionRoutePlan');
var DistributionRoute = require('./distributionRoute');

function Distribution(distribution) {
  angular.extend(this, distribution);
  if(this.date) {
    this.date = this.date.slice(0, 10); // YYYY-MM-DD
  }
  this.routes = (this.routes || []).map(function(route) {
    return new DistributionRoute(route, this);
  }, this);

  this.routePlans = this.routePlans.map(function(routePlan) {
    return new DistributionRoutePlan(routePlan, this.routes);
  }, this);
}

Distribution.prototype.status = function() {
  return this.publishedRoutePlans().length === this.routePlans.length ? 'published' : '';
};

Distribution.prototype.publishedRoutePlans = function() {
  return this.routePlans.filter(function(routePlan) {
    return routePlan.published;
  });
};

Distribution.prototype.delayedRoutes = function() {
  return this.routes.filter(function(route) {
    return route.delayForHumans();
  });
};

Distribution.prototype.delayedUnfinishedRoutes = function() {
  return this.routes.filter(function(route) {
    return route.delayForHumans() && route.status() !== 'finished' && !! route.driver.userName;
  });
};

Distribution.prototype.sum = function(type) {
  return this.routePlans.reduce(function(sum, routePlan) {
    var count = typeof routePlan[type] === 'function'
      ? routePlan[type]()
      : routePlan[type];

    return sum + count;
  }, 0);
};

Distribution.prototype.findRoutePlan = function(routePlanId) {
  return this.routePlans.filter(function(routePlan) {
    return routePlan.id === routePlanId;
  })[0];
};

Distribution.prototype.findRoute = function(routeId) {
  return this.routes.filter(function(route) {
    return route.id === routeId;
  })[0];
};

Distribution.prototype.findCustomer = function(customerId) {
  return this.customers && this.customers.filter(function(customer) {
    return customer.id === customerId;
  })[0];
};

Distribution.prototype.addCustomerNotification = function(customerId, notification) {
  var customer = this.findCustomer(customerId);

  customer && customer.addNotification(notification);
};

Distribution.prototype.updateCustomerClientTime = function(customerId, clientSideTimestampDone) {
  var customer = this.findCustomer(customerId);
  if (customer) {
    customer.clientSideTimestampDone = clientSideTimestampDone;
  }
};

Distribution.prototype.updateCustomerImage = function(customerId, image) {
  var customer = this.findCustomer(customerId);

  customer && customer.updateImage(image);
};

Distribution.prototype.updateCustomerCallLog = function(customerId, driverUsername, timestampCalled) {
  var customer = this.findCustomer(customerId);

  customer && customer.callLogs.push({ driverUsername: driverUsername, timestampCalled: timestampCalled });
};

Distribution.prototype.addCustomer = function(customer) {
  this.customers && this.customers.push(customer);
};

module.exports = Distribution;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/distribution.js
 ** module id = 168
 ** module chunks = 1
 **/